$(document).ready(function () {
    let rol = $("item_rol").val()
    $('#item-name').autocomplete({
        source: function (request, response) {
            $.ajax({
                url: '/get-suggestions-name',
                type: 'POST',
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    term: request.term
                },
                success: function (data) {
                    response($.map(data, function (item) {
                        showTitle = item.name
                        return {
                            label: showTitle,
                        }
                    }))
                }
            });
        },
        select: function (event, ui) {
            $("#item-name").val(ui.label)
        }
    });

    $('#item-ti-name').autocomplete({
        source: function (request, response) {
            $.ajax({
                url: '/get-suggestions-name-for-ti',
                type: 'POST',
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    term: request.term
                },
                success: function (data) {
                    response($.map(data, function (item) {
                        showTitle = item.name
                        return {
                            label: showTitle,
                        }
                    }))
                }
            });
        },
        select: function (event, ui) {
            $("#item-name").val(ui.label)
        }
    });

    $('#item-job_title').autocomplete({
        source: function (request, response) {
            $.ajax({
                url: '/get-suggestions-job_title',
                type: 'POST',
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    term: request.term
                },
                success: function (data) {
                    response($.map(data, function (item) {
                        showTitle = item.job_title
                        return {
                            label: showTitle,
                        }
                    }))
                }
            });
        },
        select: function (event, ui) {
            $("#item-job_title").val(ui.label)
        }
    });

    $('#item-problem').autocomplete({
        source: function (request, response) {
            $.ajax({
                url: '/get-suggestions',
                type: 'POST',
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    term: request.term
                },
                success: function (data) {
                    response($.map(data, function (item) {
                        showTitle = item.description
                        return {
                            label: showTitle,
                        }
                    }))
                }
            });
        },
        select: function (event, ui) {
            $("#item-problem").val(ui.label)
        }
    });

    $('#item-email').autocomplete({
        source: function (request, response) {
            $.ajax({
                url: '/get-suggestions-email',
                type: 'POST',
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    term: request.term
                },
                success: function (data) {
                    console.log(data)
                    response($.map(data, function (item) {
                        showTitle = item.email
                        return {
                            label: showTitle,
                        }
                    }))
                }
            });
        },
        select: function (event, ui) {
            $("#item-email").val(ui.label)
        }
    });

    $(function () {
        // Configuración del contador de caracteres
        $("#item-problem").keyup(function () {
            // Actualizamos el contador de caracteres
            var characterCount = $(this).val().length;
            $("#character-counter").text(30 - characterCount);

            // Si el usuario ha escrito más de 30 caracteres, le impedimos escribir más
            if (characterCount > 30) {
                alertError("La descripción del problema debe ser resumida y tener menos de 30 caracteres. <br> " +
                    "Si necesitas agregar una descripción más detallada lo puedes hacer en el siguiente cuadro de texto. ")
                $(this).val($(this).val().substring(0, 30));
            }
        });
    });


})
